const en_trans_itemoutlist = {
    "": "item out supervision",
    detail: "item out detail",

    label: {
        detail_show: "Show details ...",
        detail_basic: "Basic Details",
        detail_full: "Full Details",
    },

    message: {
        delete_title: "Are you sure you want to delete item out data?",
        delete_text: "Enter reason for deleting item out data",
    },

    error: {
        delete: "Failed to delete item out data",
    },

    success: {
        delete: "Item out data deleted successfully",
    },
}

export default en_trans_itemoutlist;